import { ssrIsAuthenticated } from '@scorenco/next';

import { MobileLayout, createMobilePage } from '@/layouts';

const Index = createMobilePage();

export const getServerSideProps = MobileLayout.buildGetServerSideProps(
  {
    i18n: {
      defaultLocale: 'fr',
    },
  },
  [
    async ({ req, res }, previous) => {
      try {
        await ssrIsAuthenticated({
          request: req,
          response: res,
        });
      } catch (e) {
        // Do nothing
        console.log('error : ', e);
      }

      return previous;
    },
  ]
);

export default Index;
